module.exports = __webpack_public_path__ + "media/gen.3a244c5d.mp4";